(ns teamoesterreich.lebensretter-checks
  (:require ["date-fns" :refer [differenceInYears differenceInMonths differenceInDays isFuture]]
            [teamoesterreich.util.log :as log]))

(defn check-lr-app? [actual-user]
  (:status-lebensretter-app actual-user))

(defn check-identity? [actual-user]
  (:identity-confirmed actual-user))

(defn check-profile? [actual-user]
  (:profile-complete actual-user))

(defn check-email? [actual-user]
  (:email-confirmed actual-user))

(defn check-handy? [actual-user]
  (:hdy-valid actual-user))

(defn in-6-month? [date]
  (try
    (let [_date (.toDate ^js date)]
      (log/out " ################ in-6-month? " _date)
      (<= (differenceInMonths _date (js/Date.)) 6))
    (catch js/Error e (do (log/out " ################ in-6-month ERROR:" e) false))))

(defn in-future? [date]
  (try
    (let [_date (.toDate ^js date)]
      (log/out " ################ in-future? " _date)
      (isFuture _date))
    (catch js/Error e (do (log/out " ################ in-future ERROR:" e) false))))

(defn check-age? [actual-user]
  (try
    (let [birthday (.toDate ^js (:birthday actual-user))]
      (>= (differenceInYears (js/Date.) birthday) 18))
    (catch js/Error e false)))

(defn check-first-aid? [user-documents]
  (let [valid-doc (first (reverse (sort :uploaded (filter (fn [d]
                                                            ;(log/out " ################  filter-eh  " (:valid d) (:isTraining d) (> (* 1000 (.-seconds (:valid-until d)) (js/Date.now))))
                                                            (and (> (* 1000 (.-seconds ^js (:validTo d)) (js/Date.now)))
                                                                 (not (:rejected d))
                                                                 (not (:deleted d))
                                                                 (:isTraining d)
                                                                 ))
                                                          (mapv second user-documents)))))]

    (or valid-doc)))

(defn check-selfexplain? [actual-user]
  (or (:status-lebensretter-selfexplain actual-user)))

(defn check-activated? [actual-user]
  (or (:status-lebensretter-activated actual-user)))

(defn check-all? [actual-user]
  (or (:status-lebensretter actual-user)
      (and
        (check-identity? actual-user)
        (check-profile? actual-user)
        (check-selfexplain? actual-user)
        (check-activated? actual-user)
        ))
  )
